import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPandasComponent } from './simple-icons-pandas.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPandasComponent ],
    exports:      [ SimpleIconsPandasComponent ],
    bootstrap:    []
})
export class SimpleIconsPandasModule {}
